import { createBrowserHistory } from "history";
import { enableMapSet } from "immer";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import relativeTime from "dayjs/plugin/relativeTime";
import updateLocale from "dayjs/plugin/updateLocale";
import timezone from "dayjs/plugin/timezone";
import duration from "dayjs/plugin/duration";

import configureStore from "../store/configureStore";

/** Initial store setup and more, used in index.tsx and for micro frontend wrapper component(s) */
export function initialSetup() {
    enableMapSet();

    // dayjs plugins
    dayjs.extend(utc);
    dayjs.extend(duration);
    dayjs.extend(relativeTime, {
        thresholds: [
            { l: "s", r: 59, d: "second" },
            { l: "m", r: 1 },
            { l: "mm", r: 59, d: "minute" },
            { l: "h", r: 1 },
            { l: "hh", r: 23, d: "hour" },
            { l: "d", r: 1 },
            { l: "dd", r: 29, d: "day" },
            { l: "M", r: 1 },
            { l: "MM", r: 11, d: "month" },
            { l: "y", r: 1 },
            { l: "yy", d: "year" },
        ],
    });
    dayjs.extend(updateLocale);
    dayjs.updateLocale("en", {
        relativeTime: {
            future: "in %s",
            past: "%s ago",
            s: "%d seconds",
            m: "1 minute",
            mm: "%d minutes",
            h: "1 hour",
            hh: "%d hours",
            d: "1 day",
            dd: "%d days",
            M: "1 month",
            MM: "%d months",
            y: "1 year",
            yy: "%d years",
        },
    });
    dayjs.extend(timezone);

    // Create browser history to use in the Redux store
    const history = createBrowserHistory();

    // Get the application-wide store instance, prepopulating with state from the server where available.
    const store = configureStore(history);

    return { history, store };
}
